/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Filter Drawer Collapse All Icon component.
 */
export const FilterDrawerCollapseAllIcon = ({
  color = dlsColor('grey1')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M3.75 9.00006H13.25M3.75 5.00006H13.25M3.75 13.0001H13.25M3.75 17.0001H13.25M16 4.75006L18.92 8.64339C18.96 8.69673 19.04 8.69673 19.08 8.64339L22 4.75006M16 17.7501L18.92 13.8567C18.96 13.8034 19.04 13.8034 19.08 13.8567L22 17.7501' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
};

export default FilterDrawerCollapseAllIcon;
